// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { lazy } from 'react';

import { store } from '../../../store/store';

import { HydrateFallback } from '../../Loaders/RootLoader/rootLoader';
import { withSuspense } from '../../../hooks/LazyLoader/withSuspense';

// Show Loader
import { showByIdLoader } from '../../Loaders/ShowByIdLoader/showByIdLoader';
import { blockLoader } from '../../Loaders/BlockLoader/blockLoader';

const lazyPage = path => lazy(() => import(`../../Pages/${path}`));

const ShowList = lazyPage('ShowList');
const Show = lazyPage('Show');
const LaunchShow = lazyPage('LaunchShow');
const BlockById = lazyPage('BlockById');
const BlockManager = lazyPage('BlockManager');
const Dialogue = lazyPage('Dialogue');
const People = lazyPage('People');
const BlockScenes = lazyPage('BlockScenes');
const Assets = lazyPage('Assets');
const ShowScenesType = lazyPage('ShowScenesType');
const MediaType = lazyPage('MediaType');
const VirtualMonitors = lazyPage('VirtualMonitors');
const Graphics = lazyPage('Graphics');
const LowerThirds = lazyPage('LowerThirds');
const Equipment = lazyPage('Equipment');
const Dashboard = lazyPage('Dashboard');
const Scenes = lazyPage('ScenesAll');

// Nested Routes for Show Blocks
const blockRoutes = [
  {
    index: true,
    element: withSuspense(BlockManager),
  },
  { path: 'scenes/:sceneDimension', element: withSuspense(BlockScenes) },
  { path: 'library/:assetType', element: withSuspense(Assets) },
  { path: 'dimension', element: withSuspense(ShowScenesType) },
  { path: 'people', element: withSuspense(People) },
  { path: 'media', element: withSuspense(MediaType) },
  { path: 'graphics', element: withSuspense(Graphics) },
  { path: 'monitors', element: withSuspense(VirtualMonitors) },
  { path: 'dialogue', element: withSuspense(Dialogue) },
  { path: 'lower-thirds', element: withSuspense(LowerThirds) },
  { path: 'equipment/:equipmentId', element: withSuspense(Equipment) },
];

// Library Routes
const libraryRoutes = [
  {
    index: true,
    element: withSuspense(Scenes),
  },
];

// Show Routes

const showRoutes = [
  {
    index: true,
    element: withSuspense(ShowList),
  },
  {
    path: 'show/:showId',
    loader: showByIdLoader,
    shouldRevalidate: ({ currentParams, nextParams }) => {
      const companyUuid = store.getState().companies.company?.company_uuid;
      return (
        currentParams.showId !== nextParams.showId || showByIdLoader.lastCompanyUuid !== companyUuid
      );
    },
    HydrateFallback,
    element: withSuspense(Show),
    children: [
      {
        path: 'block/:blockId',
        loader: blockLoader,
        shouldRevalidate: ({ currentParams, nextParams }) => {
          return currentParams.blockId !== nextParams.blockId;
        },
        HydrateFallback,
        element: withSuspense(BlockById),
        children: blockRoutes,
      },
      {
        path: 'launch',
        element: withSuspense(LaunchShow),
      },
    ],
  },
  {
    path: 'library',
    element: withSuspense(Dashboard),
    children: libraryRoutes,
  },
];

export default showRoutes;
